export enum ValidationType {
  Valid = 'Valid',
  Warning = 'Warning',
  Invalid = 'Invalid'
}
